<script>
    // тестирование
    
    export let wrapper;
    export let data;
    export let reward;
    const check = () => {
        return true;
    }

    let bonus = 0;
    let params = Array.isArray(data.params) ? data.params[0] : data.params;
    let steps = data.steps;
    let questions = [...data.options.map((value) => ({ value, sort: Math.random() })).sort((a, b) => a.sort - b.sort).map(({ value }) => value)];
    let question = questions.shift();
    
    const handlerNext = (value) => {
        let qbtn = wrapper.querySelectorAll('button'),
            progress = wrapper.querySelector('.progress-bar');
        
        qbtn.forEach(el => {el.disabled = true});
        
        if (question.answer.toString() === value.toString()) {
            bonus += +question.bonus;
        }
        
        progress.style = 'width: ' + ((data.options.length - questions.length) * 100 / data.options.length) + '%';
        
        setTimeout(() => {
            qbtn.forEach(el => {el.disabled = false});
            
            if (questions.length) {
                question = questions.shift();
            } else {
                let step = steps.find((el) => {return +el.bonus_from <= bonus && +el.bonus_to >= bonus});
                
                if (step) {
                    reward(step.comment);
                } else {
                    reward(true);
                }
            }
        }, 750);
    };
</script>

<div>
    <div class="progress mb-3">
        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 0%"></div>
    </div>
    
    <div class="card" data-question>
        <div class="card-body">
            <h5 class="card-title text-md-center m-0">{question.label}</h5>
        </div>
    </div>
    
    <div class="row mt-3">
        <div class="col-6">
            <button type="button" class="btn btn-danger w-100 btn-lg" on:click={() => handlerNext(0)}>Нет</button>
        </div>
        <div class="col-6">
            <button type="button" class="btn btn-success w-100 btn-lg" on:click={() => handlerNext(1)}>Да</button>
        </div>
    </div>
</div>
